"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _withStateHandlers = _interopRequireDefault(require("recompose/withStateHandlers"));

var _default = (0, _withStateHandlers["default"])({
  modalShowing: false
}, {
  onCloseModal: function onCloseModal() {
    return function () {
      return {
        modalShowing: false
      };
    };
  },
  onShowModal: function onShowModal() {
    return function () {
      return {
        modalShowing: true
      };
    };
  }
});

exports["default"] = _default;